/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Last_Name_LabelInputs */

const en_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Name`)
};

const fr_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

const it_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cognome`)
};

const ru_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фамилия`)
};

const es_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apellido`)
};

const zh_cn2_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓`)
};

const ja_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`苗字`)
};

const hi_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपनाम`)
};

const pt_pt2_team_manager_last_name_label = /** @type {(inputs: Team_Manager_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrenome`)
};

/**
* | output |
* | --- |
* | "Last Name" |
*
* @param {Team_Manager_Last_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_last_name_label = /** @type {((inputs?: Team_Manager_Last_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Last_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_last_name_label(inputs)
	if (locale === "de") return de_team_manager_last_name_label(inputs)
	if (locale === "it") return it_team_manager_last_name_label(inputs)
	if (locale === "ru") return ru_team_manager_last_name_label(inputs)
	if (locale === "es") return es_team_manager_last_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_last_name_label(inputs)
	if (locale === "ja") return ja_team_manager_last_name_label(inputs)
	if (locale === "hi") return hi_team_manager_last_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_last_name_label(inputs)
	return en_team_manager_last_name_label(inputs)
});